/* libs/shared/src/lib/ui/flowchart/lib/ng-flowchart-arrow/ng-flowchart-arrow.component.scss */
svg {
  position: absolute;
  z-index: 0;
  transition: all 0.2s;
}
/*# sourceMappingURL=ng-flowchart-arrow.component.css.map */
